import { useEffect } from 'react'
import { useLocation } from 'react-router-dom'

export default function HomePage() {
  const location = useLocation()

  useEffect(() => {
    // Only redirect if we're exactly at the root path
    if (location.pathname === '/') {
      window.location.href = 'https://fireforge.ai'
    }
  }, [location.pathname])
      
  // Show a loading message while redirecting (only for root path)
  if (location.pathname === '/') {
    return (
      <div className="min-h-screen bg-gray-50 flex items-center justify-center">
        <div className="text-center">
          <div className="flex items-center justify-center mb-6">
            <img
              className="h-16 w-auto mr-4"
              src="/logo/fireforge-logo.svg"
              alt="FireForge"
            />
            <h1 className="text-3xl font-bold text-gray-900">FireForge</h1>
          </div>
          <p className="text-lg text-gray-600 mb-4">Redirecting to fireforge.ai...</p>
          <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-primary mx-auto"></div>
        </div>
          </div>
    )
  }

  // This shouldn't normally be reached since we only use HomePage for root path
  return (
    <div className="min-h-screen bg-gray-50 flex items-center justify-center">
      <div className="text-center">
        <h1 className="text-2xl font-bold text-gray-900">FireForge App</h1>
        <p className="text-gray-600 mt-2">Welcome to the FireForge application platform.</p>
      </div>
    </div>
  )
} 